import { useState, useEffect } from 'react';
import {
  IAutomatedEmailCampaignListPayload,
  IPaginationAPIResponse,
  getJobAutomatedEmailLogsList,
  IEmailLogGroup,
} from 'wisestep-api';

const useGetJobEmailLogs = (search: IAutomatedEmailCampaignListPayload) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [emailList, setEmailList] = useState<IPaginationAPIResponse<IEmailLogGroup>>(
    {} as IPaginationAPIResponse<IEmailLogGroup>
  );

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { data } = await getJobAutomatedEmailLogsList(search);
        if (data) {
          setEmailList(data);
        }
      } catch {
        console.error('Error while getting the setting campaign list');
      } finally {
        setLoading(false);
      }
    })();
  }, [search]);

  return { emailList, loading };
};

export default useGetJobEmailLogs;
